import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { generalSettings } from "../../../../main/settings";

@Component({
  selector: "edm-warning-dialog",
  templateUrl: "./dialog.warning.component.html",
  styleUrls: ["./dialog.warning.component.scss"],
  standalone: false,
})
export class WarningDialogComponent implements OnInit {
  @Input() title: string;
  @Input() content: string;
  @Input() confirmButton: string;

  pathBaseTranslate: string = "shared.dialog.warning.";

  constructor(
    public activeModal: NgbActiveModal,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    if (!this.confirmButton) {
      this.confirmButton = this.getTranslate("confirmLabel");
    }

    if (!this.title) {
      this.title = this.getTranslate("defaultTitle");
    }
  }

  getTranslate(key: string): string {
    return this.translate.instant(this.pathBaseTranslate + key);
  }

  closeModal(): void {
    this.activeModal.close();
  }

  iconCustomLayoutClass(): string {
    return generalSettings.timelineIconsLayout + "-icon";
  }

  iconTypeLayoutClass(): string {
    return generalSettings.iconsType + "-icons-type";
  }

  buttonCustomLayoutCss(): string {
    return generalSettings.buttonLayout + "-btn";
  }
}
